import { useHttp } from '../http'

export const useClubContentHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`club-contents/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`club-contents`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`club-contents/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`club-contents`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`club-contents/${id}`)
    }

    const photo = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().post(`club-contents/${id}/photo`, payload)
    }

    return {
        find,
        create,
        update,
        get,
        del,
        photo
    }
}
